import React, { useState } from "react";
import ContentName from "./ContentName";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { imgUrl } from "../../../api/api";
import { ReactComponent as JpgIcon } from "../../../Assets/images/jpgIcon.svg";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, Menu, MenuItem } from "@mui/material";
import { Document, Page } from "react-pdf";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { Layers } from "lucide-react";
import TemplatePreview from "./TemplatePreview";
import { CopyAllOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { copyTemplate } from "../../../Redux/Actions/contentAction";
import toast from "react-hot-toast";
import { useContextUserId } from "../../../hooks/useSupportContext";
import { tr } from "../../../i18n";
function Template({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.User);
  const contextUserId = useContextUserId();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
   const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
   
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = (type, obj) => {
      setAnchorEl(null);
    };

    const handleCopyTemplate = () => {
      if (data.type === "template") {
        dispatch(copyTemplate(data.id, contextUserId));
        toast.success(tr("Template copied successfully!"));
        setAnchorEl(null);
      } else {
        toast.error(tr("Only templates can be copied"));
      }
    };
  return (
    <>
      <div className="content-item" key={data.key}>
        <div className="content-image">
          {!readOnly && (
            <div className="content-del-icon">
              <MoreVertIcon
                onClick={handleClick}
                style={{ color: "var(--primary-color)" }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              />
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
              >
                <MenuItem onClick={handleCopyTemplate}>
                  <CopyAllOutlined
                    style={{ color: "var(--primary-color)", marginRight: "8px" }}
                  />
                  {tr("Copy")}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => deleteSingleContent(data.id)}>
                  <DeleteOutlineIcon
                    style={{ color: "var(--primary-color)", marginRight: "8px" }}
                  />
                  {tr("Delete")}
                </MenuItem>
              </Menu>
            </div>
          )}
          <TemplatePreview id={data.id} canva={data.canva} />
          {/* <img src={`${imgUrl}/${data.url}`} alt="" /> */}
        </div>
        <div className="content-bottom">
          <ContentName data={data} readOnly={readOnly} />
          <p
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span>
              <Layers
                style={{
                  fontSize: "17px",
                  color:"var(--primary-color)"
                }}
              />
            </span>
            <span>{data.type=="template" && tr("Template")}</span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Template;
